module.exports = __webpack_public_path__ + "static/img/1.4a4184e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/1.png
// module id = R84i
// module chunks = 1